import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  constructor(private _domSanitizer: DomSanitizer) {}
  /**
   * Transforms data to expected format
   * @param value - value
   * @param arg - arg
   * @param arg1 - arg1
   * @param separator - separator
   */
  transform(value: string, args: string , arg1: string): any {
    return this._domSanitizer.bypassSecurityTrustHtml(this.stylize(value, args , arg1));
  }

  /**
   * Transforms data to expected format
   * @param text - text
   * @param link - name
   * @param name - name
   * @return string - string
   */
  private stylize(text: string, link: string, replaceChr: string): string {
    let stylizedText = '';
    if (text && text.length > 0 && text.includes('@') && link) {
      for (const t of text.split(' ')) {
        if (t.startsWith('@') && t.length > 1) {
          const selectedText = t.split('');
          // removing @ from array
          selectedText.shift();
          let innerText = selectedText.join('');
          // checking for replace character
          if (replaceChr) {
            //  Replacing character
            innerText = innerText.replace(replaceChr, ' ');
          }
          stylizedText += `<a href="${link}">${innerText}</a> `;
        } else {
            stylizedText += t + ' ';
        }
      }
      return stylizedText;
    } else {
        return text;
    }
  }
}

